/** PC/WAP 底部导航中的协议列表模板，使用模块外层 template_id。 */
export const LEGAL_LINKS_TEMPLATE_ID = 2;

interface FooterLegalModule {
  id?: number;
  template_id?: number;
  content?: unknown;
}

export interface FooterLegalLink {
  key: string;
  href: string;
  label: string;
  firstLevelTitle: string;
  firstLevelIndex: number;
  secondLevelIndex: number;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** 按接口顺序展开协议模块；后台未配置或条目不完整时不补前端默认项。 */
export function getFooterLegalLinks(navList: readonly FooterLegalModule[]): FooterLegalLink[] {
  return navList.flatMap((module, moduleIndex) => {
    if (module.template_id !== LEGAL_LINKS_TEMPLATE_ID || !isRecord(module.content)) return [];
    const list: unknown = module.content.list;
    if (!Array.isArray(list)) return [];
    const firstLevelTitle =
      typeof module.content.layout_title === 'string'
        ? module.content.layout_title
        : typeof module.content.template_title === 'string'
          ? module.content.template_title
          : '';

    return list.flatMap((item: unknown, itemIndex): FooterLegalLink[] => {
      if (!isRecord(item) || typeof item.href !== 'string' || typeof item.title !== 'string') {
        return [];
      }
      const href = item.href.trim();
      const label = item.title.trim();
      if (!href || !label) return [];

      return [
        {
          key: `${module.id ?? moduleIndex}:${itemIndex}`,
          href,
          label,
          firstLevelTitle,
          firstLevelIndex: moduleIndex,
          secondLevelIndex: itemIndex,
        },
      ];
    });
  });
}
